import { identify, resetAnalytics } from '../utils/analytics';
import { getSessionUser, isSignedInUser, onAuthChange } from './authAccount';

// Rattache la personne PostHog au compte upScale.
//
// Pourquoi ici et pas dans useAccountAuth : ce hook ne se monte qu'a l'ouverture
// de la feuille de connexion. Quelqu'un qui est deja connecte et n'ouvre jamais
// cette feuille ne serait jamais identifie, alors que c'est precisement le cas
// courant. On branche donc au demarrage, une fois pour toute la session.
//
// Ce qu'on envoie : l'uuid Supabase, et rien d'autre. Pas l'email, pas de nom.
// L'Admin a deja l'adresse par GoTrue et joint sur cet id, il n'y a aucune
// raison de deposer une donnee nominative de plus chez PostHog.
//
// Les sessions ANONYMES restent anonymes (garde isSignedInUser) : une session
// anonyme est posee au boot sur chaque appareil, les identifier creerait une
// personne PostHog par appareil et ruinerait la fusion que identify sert
// justement a obtenir.

// L'id deja envoye a PostHog. Evite de re-identifier a chaque evenement d'auth
// (le SDK tolere les appels repetes, mais chacun envoie un $identify de plus).
let identifiedId = null;

// A appeler a chaque changement de session. Trois passages possibles :
//  - anonyme ou deconnecte -> identifiedId retombe a null,
//  - premiere connexion    -> identify, et l'historique anonyme de l'appareil
//                             fusionne dans la personne du compte,
//  - autre compte          -> reset AVANT identify. Le repli OAuth et la
//                             reconnexion par code remplacent la session sans
//                             passer par une deconnexion : sans ce reset,
//                             l'appareil resterait marque au compte precedent.
export function syncAnalyticsIdentity(user) {
  const id = isSignedInUser(user) ? user.id : null;
  if (id === identifiedId) return;
  // Deconnexion comme bascule de compte : l'appareil redevient anonyme d'abord.
  if (identifiedId) resetAnalytics();
  identifiedId = id;
  if (id) identify(id);
}

// Branche l'identite au demarrage, puis la suit. Rend la fonction de
// desabonnement (l'app ne s'en sert pas, les tests si).
export function bindAnalyticsIdentity() {
  getSessionUser()
    .then(syncAnalyticsIdentity)
    .catch(() => {
      // Session illisible au boot : onAuthChange rattrapera le prochain etat.
    });
  return onAuthChange(syncAnalyticsIdentity);
}

// Reservee aux tests : remet l'etat module a zero entre deux cas.
export function resetAnalyticsIdentityForTests() {
  identifiedId = null;
}
